module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_L1-385375c13fbb6aa7a94c8ce0f3fc2b86.webp";